import { render, staticRenderFns } from "./GraphDetail86.vue?vue&type=template&id=081e66a6&scoped=true"
import script from "./GraphDetail86.vue?vue&type=script&lang=js"
export * from "./GraphDetail86.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081e66a6",
  null
  
)

export default component.exports